<template>
    <div class="splitter-container" :id="data.sp_id" :class="{'hide': hide}">
        <splitter-title :splitter="data" :title="data.sp_label" :nivel="nivel" @open-menu="openMenu"/>
        <div v-if="!hide" class="splitter-connections-container">
            <div class="connections-wrapper connections-wrapper-left">
                <Connection
                    v-for="(object, index) in data.inPorts"
                    :data="object" 
                    :key="index" 
                    side="left"
                    :list="list"
                    :label="getObjectConnected(object)"
                    :fiber-colors="fiberColors"
                    :cables="cables"
                    :splitters="splitters"
                />
            </div>
            <div :style="{width: '195px'}" ref="centerLine" class="lines-wrapper">
                <img class="lines-container-img" :src="require(`@/assets/splitterConnection.png`)" /> 
                <svg class="lines-container">
                    <line 
                        v-for="(point, index) in points" 
                        :key="index" 
                        :x1="point.x1" 
                        :y1="point.y1" 
                        :x2="point.x2" 
                        :y2="point.y2" 
                        class="connection-line"
                        :stroke-dasharray="'5 4'"
                    />
                </svg>
            </div>
            <div class="connections-wrapper connections-wrapper-right">
                <Connection
                    v-for="(object, index) in data.outPorts"
                    :data="object" 
                    :key="index" 
                    side="right" 
                    :list="list"
                    :label="getObjectConnected(object)"
                    :fiber-colors="fiberColors"
                    :cables="cables"
                    :splitters="splitters"
                />
            </div>
        </div>
    </div>
</template>
  
<script>
  import SplitterTitle from './SplitterTitle.vue';
  import Connection from './Connection.vue';
  export default {
    name: "Splitter",
    components: {
        SplitterTitle,
        Connection
    },
    props:{
      data: {
        type: Object
      },
      nivel: {
        type: Number
      },
      list: {
        type: Array
      },
      fiberColors: {
        type: Array
      },
      hide: {
        type: Boolean
      },
      cables: {
        type: Array
      },
      splitters : {
        type: Array
      }
    },
    data(){
        return {
            points : [],
        }
    },
    mounted(){
        this.getLinesList();
    },
    watch:{
        data:{
            handler(){
                this.getLinesList()
            },
            deep: true  // Enable deep watching for array changes
        },
    },
    methods: {
        openMenu(e, splitter, nivel){
            this.$emit('open-menu', e, splitter, nivel);
        },
        calculateContainerHeiht(numberOfInPorts, numberOfOutPorts){
            const higherPorts = Math.max(numberOfInPorts, numberOfOutPorts);
            let portsHeight = higherPorts * 25;
            if(higherPorts > 1){
                const gapHeight = (higherPorts - 1) * 10;
                portsHeight = portsHeight + gapHeight
            }
            return portsHeight;
        },
        getLinesList(){
            let inPorts = [];
            let outPorts = [];
            const centerHeight = this.calculateContainerHeiht(this.data.inPorts.length, this.data.outPorts.length)/2;
            const leftWidth = 75;
            const rightWidth = 125;
            this.data.inPorts.forEach(item => { 
                    inPorts.push(item.pt_id);
            });
            this.data.outPorts.forEach(item => {
                    outPorts.push(item.pt_id);
            });
            const inPortsList = inPorts.map((item, index) => {
                return {
                    x1: leftWidth,
                    y1: centerHeight,
                    x2: 5,
                    y2: this.getHeight(inPorts.length,index + 1, centerHeight*2)
                }
            });
            const outPortsList = outPorts.map((item, index) => {
                return {
                    x1: rightWidth,
                    y1: centerHeight,
                    x2: 190,
                    y2: this.getHeight(outPorts.length, index + 1, centerHeight*2)
                }
            });
            this.points = [...inPortsList, ...outPortsList];
        },
        getHeight(total, index, totalHeight){
            const sub = ((total) * 25) + ((total - 1) * 10);
            const subHeight = totalHeight - sub;
            let height;
            if(total > 1){
                switch (index) {
                    case 1:
                        height = 12.5 + Math.ceil(subHeight/2);
                        break;
                    default:
                        height = this.calculateHeight(total, index, subHeight);
                        break;
                }
            }else{
                height = this.$refs.centerLine.offsetHeight/2;
            }
            return height;
        },
        calculateHeight(total, index, subHeight){
            let height = ((index - 1) * 25) + ((index - 1) * 9) + (12.5);
            height = height + Math.ceil(subHeight/2);
            if(index < Math.ceil(total/2)){
                height += 5
            }
            else if(index > Math.ceil(total/2)){
                height -= 2
            }
            return height;
        },
        getObjectConnected(data){
            let label;
            if(data.connectedFiber){
                label = this.getCableLabel(data.connectedFiber)
            }else if (data.connectedPort){
                const obj = this.splitters.find(item => item.sp_id === data.connectedPort.pt_splitter_id);
                if(obj){
                    label = obj.sp_label;
                }
            }
            return label;
        },
        getCableLabel(fiber){
            const cable = this.cables.find(item => item.cb_id === fiber.fb_cable_id);
            const label = cable.cb_label ? cable.cb_label :  `Cb: ${cable.cb_id}`;
            return label;
        },
    }
  };
</script>
<style scoped>
.splitter-container{
    width: 100%;
    max-width: 700px;
    background-color: white;
    border-radius: 10px;
    border: 1px solid rgb(100, 96, 96);
    margin-bottom: 5px;
    min-height: 25px;
}
.splitter-connections-container{
    display: flex;
    width: 100%;
    padding: 10px;
}
.hide{
    border: none;
    background-color: inherit;
}
.connections-wrapper{
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 10px;
}
.connections-wrapper-left{
    flex-grow: 1;
}
.connections-wrapper-right{
    width: 220px;
}
.lines-wrapper{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
}
.lines-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
}
.connection-line{
    stroke: rgb(185, 181, 181);
    height: 10px;
}
.lines-container-img{
    width: 35px;
    height: 35px;
}

</style>


// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Splicing/SplittersInfo/Splitter.vue